<template>
  <label
    v-if="sort && sortOptions?.length && sortOptions.length > 1"
    class="sort"
  >
    <span
      class="sort__label"
    >{{ $t('Sort by') }}</span>

    <select
      class="sort__select"
      @input="(event) => $emit('updateSort', (event.target as HTMLInputElement).value)"
    >
      <option
        v-for="option in sortOptions"
        :key="`sort-${option.key}`"
        :value="option.key"
        :selected="option.key === sort"
      >
        {{ $t(option.label) }}
      </option>
    </select>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  sort: string
  sortOptions: any[]
}>()

defineEmits(['updateSort'])
</script>

<style src="~layers/app/components/Paginator/Sort.css" />
